import { render } from "./referee-dashboard.vue?vue&type=template&id=28f970e4&scoped=true"
import script from "./referee-dashboard.vue?vue&type=script&lang=js"
export * from "./referee-dashboard.vue?vue&type=script&lang=js"

import "./referee-dashboard.vue?vue&type=style&index=0&id=28f970e4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f970e4"]])

export default __exports__